import { render, staticRenderFns } from "./SearchMovieView.vue?vue&type=template&id=250711bc&"
import script from "./SearchMovieView.vue?vue&type=script&lang=js&"
export * from "./SearchMovieView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports